<div class="soft-card rounded-2xl flex items-center justify-between gap-0.5">
  <div class="flex flex-col gap-2">
    <div class="flex flex-col">
      <span class="font-semibold">{{ deliveryMaterial?.bezeichnung1 }}</span>
      @if (deliveryMaterial?.bezeichnung2) {
        <span class="text-sm color-light mt-1">{{ deliveryMaterial?.bezeichnung2 }}</span>
      }
      @if (deliveryMaterial?.bezeichnung3) {
        <span class="text-sm color-light mt-1">{{ deliveryMaterial?.bezeichnung3 }}</span>
      }
    </div>
    <div>
      <span class="text-light">Art.Nr. {{ deliveryMaterial?.artikelnummer }}</span>
    </div>
  </div>
  @if (deliveryMaterial?.editable !== true) {
    <span class="text-light text-center">
    {{ $safeNavigationMigration(deliveryMaterial?.menge) | number:'1.0-6' }} {{ $safeNavigationMigration(deliveryMaterial?.einheit) | einheit }}
  </span>
  } @else {
    <div class="flex flex-row justify-end flex-nowrap center-v end pl-3 border-box">
      <soft-ds-quantity-input
        [value]="deliveryMaterial?.menge ?? 0"
        [min]="0"
        [unit]="
              (deliveryMaterial?.einheit?.length ?? 0) > 0
                ? (deliveryMaterial?.einheit ?? 'EH')
                : 'EH'
            "
        (valueChange)="onChange($event)"
      ></soft-ds-quantity-input>
      <span
        class="detail-area cursor-pointer ml-6 flex items-center justify-center self-center"
        (click)="onEditBeweClick()"
      >
            <i class="fa-regular fa-ellipsis-vertical"></i>
          </span>
    </div>
  }
</div>

<!-- <div class="soft-card rounded-2xl">
  <div class="flex flex-row justify-between flex-nowrap center p-1 border-box">
    <div class="flex flex-col">
      <div
        [ngClass]="
          (deliveryMaterial?.bezeichnung1?.length || 0) < 1 &&
          (deliveryMaterial?.bezeichnung2?.length || 0) < 1 &&
          !deliveryMaterial?.menge
            ? 'font-semibold'
            : 'text-sm color-light'
        "
      >
        <div class="flex items-center gap-2">
          Art.Nr. {{ deliveryMaterial?.artikelnummer }}
          <soft-serial-number-view
            editable
            [deliveryNoteId]="idKopfLf"
            [productId]="deliveryMaterial?.idartstamm"
            [beweLfId]="deliveryMaterial!.id"
            [serialNumber]="deliveryMaterial?.seriennr"
            (serialNumberChange)="patchBewe(deliveryMaterial?.id, $event)"
          />
        </div>

        @if ((deliveryMaterial?.vermerk?.length || 0) > 0) {
          <i class="fa-regular fa-note-sticky info-icon"></i>
        }
      </div>
      <span class="mt-1 font-semibold">{{ deliveryMaterial?.bezeichnung1 }}</span>
      @if (deliveryMaterial?.bezeichnung2) {
        <div class="text-sm color-light mt-1">{{ deliveryMaterial?.bezeichnung2 }}</div>
      }
      @if (deliveryMaterial?.bezeichnung3) {
        <div class="text-sm color-light mt-1">{{ deliveryMaterial?.bezeichnung3 }}</div>
      }
      @if (deliveryMaterial?.beschreibung) {
        <div class="text-sm color-light mt-1">{{ deliveryMaterial?.beschreibung }}</div>
      }
      @if (deliveryMaterial?.zeilentext) {
        <div
          [ngClass]="
            (deliveryMaterial?.bezeichnung1?.length ?? 0) < 1 &&
            (deliveryMaterial?.bezeichnung2?.length ?? 0) < 1 &&
            !deliveryMaterial?.artikelnummer
              ? 'mt-1 font-semibold'
              : 'color-light mt-1'
          "
        >
          {{ deliveryMaterial?.zeilentext }}
        </div>
      }
    </div>
    <div class="flex flex-col end">
      @if (deliveryMaterial?.editable !== true) {
        <div class="flex flex-row justify-end text-base font-semibold">
          {{ deliveryMaterial?.menge }} {{ deliveryMaterial?.einheit }}
        </div>
      } @else {
        <div class="flex flex-row justify-end flex-nowrap center-v end pl-3 border-box">
          <soft-ds-quantity-input
            [value]="deliveryMaterial?.menge ?? 0"
            [min]="0"
            [unit]="
              (deliveryMaterial?.einheit?.length ?? 0) > 0
                ? (deliveryMaterial?.einheit ?? 'EH')
                : 'EH'
            "
            (valueChange)="onChange($event)"
          ></soft-ds-quantity-input>
          <span
            class="detail-area cursor-pointer ml-6 flex items-center justify-center self-center"
            (click)="onEditBeweClick()"
          >
            <i class="fa-regular fa-ellipsis-vertical"></i>
          </span>
        </div>
      }
      <div class="flex flex-row justify-end">
        @for (eh of deliveryMaterial?.arteheingaben; track eh; let first = $first) {
          <span class="text-gray-500">
            @if (first) {
              =
            } @else {
              &nbsp;+
            }
            {{ eh?.menge }} {{ eh?.arteh }}
          </span>
        }
      </div>
    </div>
  </div>
</div> -->
